// extracted by mini-css-extract-plugin
module.exports = {"features":"style_features__1r1I6","red":"style_red__3xxyv","modalInfo":"style_modalInfo__1JIaZ","info":"style_info__3G8xz"};